export const OPEN_ALERT = 'OPEN_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';

export const openAlert = (options) => {
  return { type: OPEN_ALERT, options };
};
export const closeAlert = () => {
  return { type: CLOSE_ALERT };
};
